var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('HomeHeader'),_c('HomeAbout'),_c('HomeNews'),_c('HomePublication'),_c('HomeApprendreAgir'),_c('HomeWork'),_c('HomeCta')],1)}
var staticRenderFns = []

export { render, staticRenderFns }